var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-div', _vm.displayClasses],style:(_vm.displayedStyles),on:{"click":_vm.onClicked}},[(_vm.to !== undefined)?_c('nuxt-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }